import styled from 'styled-components';
import tw from 'twin.macro';
import { ContentContainer } from 'components/content-container/content-container';
import { Stack } from 'components/stack/stack';

export const ContentWrapper = styled(Stack)`
  ${tw`pb-2`}
`;

export const ContentContainerWrapper = styled(ContentContainer)`
  padding: 0 16px 16px 16px;
`;

export const SearchResultsSectionTitle = styled.div`
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  margin-top: 20px;
`;

export const SearchResultsSectionSubTitle = styled.div`
  font-size: 16px;
  margin-bottom: 40px;
  text-align: center;
`;

const ADS_WIDTH = 340;

export const LeftColumn = styled.div`
  ${tw`pb-12`}
  height: 100%;
  min-height: 100%;
  flex: 1;
`;

export const RightColumn = styled.div`
  ${tw`flex pb-12 pl-8`}
  width: ${ADS_WIDTH}px;
  min-width: ${ADS_WIDTH}px;
  height: 100%;
  min-height: 100%;
  flex: 1;
`;

export const AdPlaceholder = styled.div`
  width: 300px;
  min-height: 340px;
`;
